import type { Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const VerifyVINButtonStyle: StyleExtend<Theme> = {
  width: 'fit-content',
  textAlign: 'left',
  p: 0,
  color: (theme) => theme.palette.customColors.copper,
  textTransform: 'none',
  '&:hover': {
    textDecoration: 'underline',
    background: 'transparent',
  },
  '&:active': {
    background: 'transparent',
  },
};

export const VerifyVINButtonTextStyle: StyleExtend<Theme> = {
  fontSize: '14px !important',
  fontWeight: '700',
  color: (theme) => theme.palette.customColors.copper,
};
